import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor( 
    private router:Router,
    private http: HttpClient, 
    public snackBar: MatSnackBar, 
  ){ 

  }

  grpAdmin = "Admin";
  usrAdmin = "it@kccamc.com";
  kccEmail = [ "@kccamc.com", "@kccholding.co.th" ];


  ACCESS_RIGHT = {

    ADMIN:{
      TITLE : "Admin",
      RIGHT:{
        GROUP:{
          ID    : "ARGT-ADM-GRP",
          TITLE : "User Group"
        },
        MEMBER:{
          ID    : "ARGT-ADM-MEM",
          TITLE : "Group Member"
        },
        RIGHT:{
          ID    : "ARGT-ADM-RGT",
          TITLE : "Access Right"
        },
        USER:{
          ID    : "ARGT-ADM-USR",
          TITLE : "User"
        },
        LOG:{
          ID    : "ARGT-ADM-LOG",
          TITLE : "Log"
        },
        NOTI:{
          ID    : "ARGT-ADM-NOTI",
          TITLE : "Notification"
        },
      }
    },

    HOU:{
      TITLE : "Housing",
      RIGHT:{
        HOU_VIEW:{
          ID    : "ARGT-HOU-VIEW",
          TITLE : "Housing Module - View"
        },
        HOU_NOTE:{
          ID    : "ARGT-HOU-NOTE",
          TITLE : "Housing Module - Note"
        }
      }
    },

    SME:{
      TITLE : "SME/Corporate",
      RIGHT:{
        SME_VIEW:{
          ID    : "ARGT-SME-VIEW",
          TITLE : "SME/Corporate Module - View"
        },
        SME_NOTE:{
          ID    : "ARGT-SME-NOTE",
          TITLE : "SME/Corporate Module - Note"
        }
      }
    },

    COLLATERAL:{
      TITLE : "Collateral",
      RIGHT:{
        CLT_LIST:{
          ID    : "ARGT-CLT-LIST",
          TITLE : "Collateral List"
        },
        CLT_DETAIL:{
          ID    : "ARGT-CLT-DETAIL",
          TITLE : "Collateral Detail"
        },
        CLT_EST:{
          ID    : "ARGT-CLT-EST",
          TITLE : "Collateral - Estimation : View"
        },
        CLT_EST_ADD:{
          ID    : "ARGT-CLT-EST-ADD",
          TITLE : "Collateral - Estimation : Add new"
        },
        CLT_EST_DEL:{
          ID    : "ARGT-CLT-EST-DEL",
          TITLE : "Collateral - Estimation : Delete"
        },
        CLT_INSU:{
          ID    : "ARGT-CLT-INSU",
          TITLE : "Collateral - Insurance : View"
        },
        CLT_INSU_ADD:{
          ID    : "ARGT-CLT-INSU-ADD",
          TITLE : "Collateral - Insurance : Add new"
        },
        CLT_INSU_DEL:{
          ID    : "ARGT-CLT-INSU-DEL",
          TITLE : "Collateral - Insurance : Delete"
        },
        CLT_REDEEM:{
          ID    : "ARGT-CLT-RDM",
          TITLE : "Collateral - ไถ่ถอน (จ่ายเงินปิด)"
        },
        CLT_SELL:{
          ID    : "ARGT-CLT-SELL",
          TITLE : "Collateral - ไถ่ถอน (ขายทอดตลาด)"
        },
        CLT_CONVERT:{
          ID    : "ARGT-CLT-CVT",
          TITLE : "Collateral - ตีทรัพย์ชำระหนี้"
        },
        CLT_TO_NPA:{
          ID    : "ARGT-CLT-TO-NPA",
          TITLE : "Collateral - ยกซื้อ NPA"
        },
      }
    },

    NPA:{
      TITLE : "NPA",
      RIGHT:{
        NPA_LIST:{
          ID    : "ARGT-NPA-LIST",
          TITLE : "NPA List"
        },
        NPA_LIST_EDIT_OPR:{
          ID    : "ARGT-NPA-LIST-EDIT-OPR",
          TITLE : "NPA List : Operation Editor"
        },
        NPA_LIST_EDIT_AM:{
          ID    : "ARGT-NPA-LIST-EDIT-AM",
          TITLE : "NPA List : AM Editor"
        },
        NPA_DETAIL:{
          ID    : "ARGT-NPA-DETAIL",
          TITLE : "NPA Detail"
        },
        NPA_TRAN:{
          ID    : "ARGT-NPA-TRAN",
          TITLE : "NPA - Transfer"
        },
        NPA_REPORT:{
          ID    : "ARGT-NPA-REPORT",
          TITLE : "NPA - Reports"
        },
        NPA_EST:{
          ID    : "ARGT-NPA-EST",
          TITLE : "NPA - Estimation : View"
        },
        NPA_EST_ADD:{
          ID    : "ARGT-NPA-EST-ADD",
          TITLE : "NPA - Estimation : Add new"
        },
        NPA_EST_EDIT:{
          ID    : "ARGT-NPA-EST-EDIT",
          TITLE : "NPA - Estimation : Edit"
        },
        NPA_EST_DEL:{
          ID    : "ARGT-NPA-EST-DEL",
          TITLE : "NPA - Estimation : Delete"
        },
        NPA_INSU:{
          ID    : "ARGT-NPA-INSU",
          TITLE : "NPA - Insurance : View"
        },
        NPA_INSU_ADD:{
          ID    : "ARGT-NPA-INSU-ADD",
          TITLE : "NPA - Insurance : Add new"
        },
        NPA_INSU_EDIT:{
          ID    : "ARGT-NPA-INSU-EDIT",
          TITLE : "NPA - Insurance : Edit"
        },
        NPA_INSU_DEL:{
          ID    : "ARGT-NPA-INSU-DEL",
          TITLE : "NPA - Insurance : Delete"
        },
      }
    },


    CHQ:{
      TITLE : "Cheque",
      RIGHT:{
        CHQ_VIEW:{
          ID    : "ARGT-CHQ-VIEW",
          TITLE : "Cheque - View"
        },
        CHQ_NEW:{
          ID    : "ARGT-CHQ-NEW",
          TITLE : "Cheque - เพิ่มเข้าระบบ"
        },
        CHQ_ASG:{
          ID    : "ARGT-CHQ-ASG",
          TITLE : "Cheque - Assign"
        },
        CHQ_DEL:{
          ID    : "ARGT-CHQ-DEL",
          TITLE : "Cheque - ลบ"
        }
      }
    },


    CDT:{
      TITLE : "Money (without Cash)",
      RIGHT:{
        CDT_VIEW:{
          ID    : "ARGT-CDT-VIEW",
          TITLE : "Money (without Cash) - View"
        },
        CDT_NEW:{
          ID    : "ARGT-CDT-NEW",
          TITLE : "Money (without Cash) - เพิ่มเข้าระบบ"
        },
        CDT_APV:{
          ID    : "ARGT-CDT-APV",
          TITLE : "Money (without Cash) - อนุมัติ"
        }
      }
    },


    TTB:{
      TITLE : "TTB",
      RIGHT:{
        TTB_VIEW:{
          ID    : "ARGT-TTB-VIEW",
          TITLE : "TTB - View"
        },
        TTB_IMP:{
          ID    : "ARGT-TTB-IMP",
          TITLE : "TTB - Import"
        },
        TTB_ASG:{
          ID    : "ARGT-TTB-ASG",
          TITLE : "TTB - Assign"
        },
        TTB_INFO:{
          ID    : "ARGT-TTB-INFO",
          TITLE : "TTB - Information"
        },
        TTB_RECP_NO:{
          ID    : "ARGT-TTB-RECP-NO",
          TITLE : "TTB - Print Recp No"
        }
      }
    },

    IBZ:{
      TITLE : "IBIZ",
      RIGHT:{
        IBZ_VIEW:{
          ID    : "ARGT-IBIZ-VIEW",
          TITLE : "IBIZ - View"
        },
        IBZ_IMP:{
          ID    : "ARGT-IBZ-IMP",
          TITLE : "IBIZ - Import"
        },
        IBZ_ASG:{
          ID    : "ARGT-IBIZ-ASG",
          TITLE : "IBIZ - Assign"
        }
      }
    },

    TDR:{
      TITLE : "TDR",
      RIGHT:{
        TDR_VIEW:{
          ID    : "ARGT-TDR-VIEW",
          TITLE : "TDR - View"
        },
        TDR_IMP:{
          ID    : "ARGT-TDR-IMP",
          TITLE : "TDR - Import"
        },
        TDR_DEL:{
          ID    : "ARGT-TDR-DEL",
          TITLE : "TDR - Delete"
        },
        TDR_EXP:{
          ID    : "ARGT-TDR-EXP",
          TITLE : "TDR - Export"
        }
      }
    },

    CEIR:{
      TITLE : "CEIR",
      RIGHT:{
        CEIR_VIEW:{
          ID    : "ARGT-CEIR-VIEW",
          TITLE : "CEIR - View"
        },
        CEIR_IMP:{
          ID    : "ARGT-CEIR-IMP",
          TITLE : "CEIR - Import"
        },
        CEIR_DEL:{
          ID    : "ARGT-CEIR-DEL",
          TITLE : "CEIR - Delete"
        },
        CEIR_EXP:{
          ID    : "ARGT-CEIR-EXP",
          TITLE : "CEIR - Export"
        }
      }
    },

    BANK_RATE:{
      TITLE : "MLR, MRR",
      RIGHT:{
        BANKRATE_VIEW:{
          ID    : "ARGT-BANKRATE-VIEW",
          TITLE : "MLR, MRR"
        },
        // BANKRATE_INS:{
        //   ID    : "ARGT-BANKRATE-IMP",
        //   TITLE : "MLR, MRR - Import"
        // },
        // BANKRATE_DEL:{
        //   ID    : "ARGT-BANKRATE-DEL",
        //   TITLE : "MLR, MRR - Delete"
        // },
        // BANKRATE_EXP:{
        //   ID    : "ARGT-BANKRATE-EXP",
        //   TITLE : "MLR, MRR - Export"
        // }
      }
    },

    KCC_CEIR:{
      TITLE : "KCC CEIR",
      RIGHT:{
        // CEIR_CAL:{
        //   ID    : "ARGT-KCC-CEIR-CAL",
        //   TITLE : "KCC CEIR - Calculate"
        // },
        CEIR_VIEW:{
          ID    : "ARGT-KCC-CEIR-VIEW",
          TITLE : "KCC CEIR - View"
        },
        // CEIR_DEL:{
        //   ID    : "ARGT-KCC-CEIR-DEL",
        //   TITLE : "KCC CEIR - Delete"
        // },
        CEIR_EXP:{
          ID    : "ARGT-KCC-CEIR-EXP",
          TITLE : "KCC CEIR - Export"
        }
      }
    },

    PV:{
      TITLE : "PV",
      RIGHT:{
        PV_VIEW:{
          ID    : "ARGT-PV-VIEW",
          TITLE : "PV - View"
        },
        PV_IMP:{
          ID    : "ARGT-PV-IMP",
          TITLE : "PV - Import"
        },
        PV_DEL:{
          ID    : "ARGT-PV-DEL",
          TITLE : "PV - Delete"
        },
        PV_EXP:{
          ID    : "ARGT-PV-EXP",
          TITLE : "PV - Export"
        }
      }
    },

    KCC_PV:{
      TITLE : "KCC PV",
      RIGHT:{
        // PV_CAL:{
        //   ID    : "ARGT-KCC-PV-CAL",
        //   TITLE : "KCC PV - Calculate"
        // },
        PV_VIEW:{
          ID    : "ARGT-KCC-PV-VIEW",
          TITLE : "KCC PV - View"
        },
        // PV_DEL:{
        //   ID    : "ARGT-KCC-PV-DEL",
        //   TITLE : "KCC PV - Delete"
        // },
        PV_EXP:{
          ID    : "ARGT-KCC-PV-EXP",
          TITLE : "KCC PV - Export"
        }
      }
    },

    ICIN:{
      TITLE : "เงินลงทุนส่วนเพิ่ม",
      RIGHT:{
        ICIN_VIEW:{
          ID    : "ARGT-ICIN-VIEW",
          TITLE : "เงินลงทุนส่วนเพิ่ม - View"
        },
        ICIN_IMP:{
          ID    : "ARGT-ICIN-IMP",
          TITLE : "เงินลงทุนส่วนเพิ่ม - New"
        },
        ICIN_DEL:{
          ID    : "ARGT-ICIN-DEL",
          TITLE : "เงินลงทุนส่วนเพิ่ม - Delete"
        },
        ICIN_EXP:{
          ID    : "ARGT-ICIN-EXP",
          TITLE : "เงินลงทุนส่วนเพิ่ม - Export"
        }
      }
    },

    REQ:{
      TITLE : "Request",
      RIGHT:{
        VIEW:{
          ID    : "ARGT-REQ-VIEW",
          TITLE : "Request - View"
        },
        WAV_DEF:{
          ID    : "ARGT-REQ-WAV-DEF",
          TITLE : "Request - Waive ผิดนัด"
        },
        CLS_ACC:{
          ID    : "ARGT-REQ-CLS-ACC",
          TITLE : "Request - ปิดบัญชี"
        },
        NEW_PF:{
          ID    : "ARGT-REQ-NEW-PF",
          TITLE : "Request - เพิ่ม Portfolio"
        },
        IMP_DT:{
          ID    : "ARGT-REQ-IMP-DT",
          TITLE : "Request - Import Debtor data"
        },
        IMP_CLT:{
          ID    : "ARGT-REQ-IMP-CLT",
          TITLE : "Request - Import Collateral data"
        },
        CANCEL_RECP:{
          ID    : "ARGT-REQ-CANCEL-RECP",
          TITLE : "Request - ยกเลิกเลขที่ใบเสร็จ"
        },
      }
    },

    APPROVE:{
      TITLE : "Request",
      RIGHT:{
        VIEW:{
          ID    : "ARGT-APR-VIEW",
          TITLE : "Approve - View"
        },
        WAV_DEF:{
          ID    : "ARGT-APR-WAV-DEF",
          TITLE : "Approve - Waive ผิดนัด"
        },
        CLS_ACC:{
          ID    : "ARGT-APR-CLS-ACC",
          TITLE : "Approve - ปิดบัญชี"
        },
        CLS_CLT:{
          ID    : "ARGT-APR-CLS-CLT",
          TITLE : "Approve - จ่ายเงินปิด"
        },
        SELL_CLT:{
          ID    : "ARGT-APR-SELL-CLT",
          TITLE : "Approve - ขายทอดตลาด"
        },
        CLT_TO_MONEY:{
          ID    : "ARGT-APR-CLT-TO-MONEY",
          TITLE : "Approve - ตีทรัพย์ชำระหนี้"
        },
        CLT_TO_NPA:{
          ID    : "ARGT-APR-CLT-TO-NPA",
          TITLE : "Approve - ยกซื้อ NPA"
        },
        NEW_PF:{
          ID    : "ARGT-APR-NEW-PF",
          TITLE : "Approve - เพิ่ม Portfolio"
        },
        IMP_DT:{
          ID    : "ARGT-APR-IMP-DT",
          TITLE : "Approve - Import Debtor data"
        },
        IMP_CLT:{
          ID    : "ARGT-APR-IMP-CLT",
          TITLE : "Approve - Import Collateral data"
        },
        CANCEL_RECP:{
          ID    : "ARGT-APR-CANCEL-RECP",
          TITLE : "Approve - ยกเลิกเลขที่ใบเสร็จ"
        },
      }
    },

    RPT:{
      TITLE : "Report",
      RIGHT:{
        ACC_RPT:{
          ID    : "ARGT-ACC-RPT",
          TITLE : "Accounting - รายงาน"
        },
        ACC_RPT01:{
          ID    : "ARGT-ACC-RPT01",
          TITLE : "Accounting - รายงานรับเงินประจำวัน"
        },
        ACC_RPT02:{
          ID    : "ARGT-ACC-RPT02",
          TITLE : "Accounting - รายงานรับเงินประจำเดือน"
        },
        ACC_RPT03:{
          ID    : "ARGT-ACC-RPT03",
          TITLE : "Accounting - รายงานดอกเบี้ยค้างรับประจำเดือน"
        },
        OPR_RPT:{
          ID    : "ARGT-OPR-RPT",
          TITLE : "Operation - รายงาน"
        },
        OPR_RPT01:{
          ID    : "ARGT-OPR-RPT01",
          TITLE : "Operation - การ์ดลูกหนี้"
        },
        OPR_RPT02:{
          ID    : "ARGT-OPR-RPT02",
          TITLE : "Operation - รายงานราคาประเมิน - Collateral"
        },
        OPR_RPT03:{
          ID    : "ARGT-OPR-RPT03",
          TITLE : "Operation - รายงานกรรมธรรม์ - Collateral"
        },
        OPR_RPT04:{
          ID    : "ARGT-OPR-RPT04",
          TITLE : "Operation - รายงานภาษีธุรกิจเฉพาะ (SBT)"
        },
        OPR_RPT05:{
          ID    : "ARGT-OPR-RPT05",
          TITLE : "Operation - รายงานลูกหนี้ปิดบัญชี"
        },
        OPR_RPT06:{
          ID    : "ARGT-OPR-RPT06",
          TITLE : "Operation - รายงานภาระหนี้สิ้นไตรมาส"
        },
        //-- 2022-11-24 : BEGIN
        OPR_RPT07:{
          ID    : "ARGT-OPR-RPT07",
          TITLE : "Operation - รายงานรับเงินประจำวัน - แผนกปฏิบัติการ"
        },
        //-- 2022-11-24 : BEGIN
        OPR_RPT08:{
          ID    : "ARGT-OPR-RPT08",
          TITLE : "Operation - รายงานราคาประเมิน - NPA"
        },
        OPR_RPT09:{
          ID    : "ARGT-OPR-RPT09",
          TITLE : "Operation - รายงานกรรมธรรม์ - NPA"
        },
        //-- ------------------------------------------------------------
        //-- 2022-11-24 : END
        FIN_RPT:{
          ID    : "ARGT-FIN-RPT",
          TITLE : "Financial - รายงาน"
        },
        FIN_RPT01:{
          ID    : "ARGT-FIN-RPT01",
          TITLE : "Financial - รายงานรับเงินประจำวัน"
        },
        AM_RPT:{
          ID    : "ARGT-AM-RPT",
          TITLE : "Asset Management - รายงาน"
        },
        LEG_RPT:{
          ID    : "ARGT-LEG-RPT",
          TITLE : "Legal - รายงาน"
        },
        //-- ------------------------------------------------------------
        // //-- 2022-11-17
        NPA_RPT:{
          ID    : "ARGT-NPA-RPT",
          TITLE : "NPA - รายงาน"
        },
        //-- 2024-11
        NPA_RPT01:{
          ID    : "ARGT-NPA-RPT01",
          TITLE : "NPA Summary Report"
        },
        NPA_RPT02:{
          ID    : "ARGT-NPA-RPT02",
          TITLE : "NPA Remaining Balance Report"
        },
        NPA_RPT03:{
          ID    : "ARGT-NPA-RPT03",
          TITLE : "NPA Sales Revenue Report"
        },
        NPA_RPT04:{
          ID    : "ARGT-NPA-RPT04",
          TITLE : "NPA Intrusion Report"
        },
        NPA_RPT05:{
          ID    : "ARGT-NPA-RPT05",
          TITLE : "NPA Register Report"
        },
        // NPA_RPT01:{
        //   ID    : "ARGT-NPA-RPT01",
        //   TITLE : "NPA - เคาะซื้อ"
        // },
        // NPA_RPT02:{
        //   ID    : "ARGT-NPA-RPT02",
        //   TITLE : "NPA - ค่าใช้จ่าย"
        // },
        // NPA_RPT03:{
        //   ID    : "ARGT-NPA-RPT03",
        //   TITLE : "NPA - รับโอน"
        // },
        // NPA_RPT04:{
        //   ID    : "ARGT-NPA-RPT04",
        //   TITLE : "NPA - Renovate"
        // },
        // NPA_RPT05:{
        //   ID    : "ARGT-NPA-RPT05",
        //   TITLE : "NPA - ขาย"
        // },
        // NPA_RPT06:{
        //   ID    : "ARGT-NPA-RPT06",
        //   TITLE : "NPA - คงเหลือ"
        // },
      }
    },

    LEGAL:{
      TITLE : "Legal",
      RIGHT:{
        LEGAL_000:{
          ID    : "LEGAL-000",
          TITLE : "Legal - Dashboard"
        },
        LEGAL_001:{
          ID    : "LEGAL-001",
          TITLE : "Legal - รับเอกสารฉบับจริง"
        },
        LEGAL_002:{
          ID    : "LEGAL-002",
          TITLE : "Legal - ส่งหนังสือบอกกล่าวฯ"
        },
        LEGAL_003:{
          ID    : "LEGAL-003",
          TITLE : "Legal - โอนสิทธิการรับจำนอง"
        },
        LEGAL_004:{
          ID    : "LEGAL-004",
          TITLE : "Legal - ยื่นสวมสิทธิในคดี"
        },
        LEGAL_01:{
          ID    : "LEGAL-01",
          TITLE : "Legal - ยังไม่ฟ้อง"
        },
        LEGAL_02:{
          ID    : "LEGAL-02",
          TITLE : "Legal - ฟ้องคดี"
        },
        LEGAL_03:{
          ID    : "LEGAL-03",
          TITLE : "Legal - พิพากษา"
        },
        LEGAL_041:{
          ID    : "LEGAL-041",
          TITLE : "Legal - อุทธรณ์"
        },
        LEGAL_042:{
          ID    : "LEGAL-042",
          TITLE : "Legal - ฎีกา"
        },
        LEGAL_X:{
          ID    : "LEGAL-X",
          TITLE : "Legal - เจ้าหนี้นอก"
        },
        LEGAL_05:{
          ID    : "LEGAL-05",
          TITLE : "Legal - บังคับคดี"
        },
        LEGAL_06:{
          ID    : "LEGAL-06",
          TITLE : "Legal - ประกาศขาย"
        },
        LEGAL_07:{
          ID    : "LEGAL-07",
          TITLE : "Legal - ขายได้"
        },
        LEGAL_08:{
          ID    : "LEGAL-08",
          TITLE : "Legal - รับเงินแล้ว"
        },
        LEGAL_09:{
          ID    : "LEGAL-09",
          TITLE : "Legal - ทรัพย์ NPA"
        },
        LEGAL_10:{
          ID    : "LEGAL-10",
          TITLE : "Legal - สืบทรัพย์"
        },
        LEGAL_11:{
          ID    : "LEGAL-11",
          TITLE : "Legal - ฟ้องส่วนต่าง"
        },
        LEGAL_12:{
          ID    : "LEGAL-12",
          TITLE : "Legal - ปิดบัญชี"
        },
        LEGAL_NOTE:{
          ID    : "LEGAL-NOTE",
          TITLE : "Legal - บันทึกเพิ่มเติม"
        },
      }
    },

    //-- 2022-12-14
    APP:{
      TITLE : "Application",
      RIGHT:{
        APP_USR:{
          ID    : "APP-USR",
          TITLE : "Application - User"
        },
        APP_NOTI:{
          ID    : "APP-NOTI",
          TITLE : "Application - Notification"
        },
        APP_CHAT:{
          ID    : "APP-CHAT",
          TITLE : "Application - Chat"
        },
        APP_GRP:{
          ID    : "APP-GRP",
          TITLE : "Application - User group"
        },
        APP_MEM:{
          ID    : "APP-MEM",
          TITLE : "Application - Group Member"
        },
      }
    },

  }//-- END : ACCESS_RIGHT
  //-- ==============================================================================================
  //-- ~ GET ACCESS RIGHT TITLE 
  //-- ==============================================================================================
  //-- ~ Get Title by ID
  //-- ------------------------------------------------------
  getAccessRightTitle( rightId: String ){

    for( var x in this.ACCESS_RIGHT ){
      for( var y in this.ACCESS_RIGHT[ x ].RIGHT ){

        var right = this.ACCESS_RIGHT[ x ].RIGHT[ y ];
        if( rightId == right[ "ID" ] ){
          return right[ "TITLE" ];
        }

      }
    }

    return "No Title";

  }//-- END : getAccessRightTitle 
  //-- ------------------------------------------------------
  //-- ~ Get ID by Title
  //-- ------------------------------------------------------
  getAccessRightId( rightTitle: String ){

    for( var x in this.ACCESS_RIGHT ){
      for( var y in this.ACCESS_RIGHT[ x ].RIGHT ){

        var right = this.ACCESS_RIGHT[ x ].RIGHT[ y ];
        if( rightTitle == right[ "TITLE" ] ){
          return right[ "ID" ];
        }
        
      }
    }

    return "No ID";

  }//-- END : getAccessRightId 
  //-- ~ 
  //-- ==============================================================================================
  //-- ~ Notification 
  //-- ==============================================================================================

  NOTIFICATION = {

    IBIZ:{
      TITLE : "IBIZ",
      NOTI:{
        IN:{
          ID  : "NOTI-IBZ-IN",
          TITLE : "IBIZ - In"
        },
        ASSIGN:{
          ID  : "NOTI-IBZ-ASGN",
          TITLE : "IBIZ - Assign"
        },
        OUT:{
          ID  : "NOTI-IBZ-OUT",
          TITLE : "IBIZ - Out"
        },
      }
    },

    MOVEMENT:{
      TITLE : "LEGAL",
      NOTI:{
        IN:{
          ID  : "NOTI-IBZ-IN",
          TITLE : "IBIZ - In"
        },
        ASSIGN:{
          ID  : "NOTI-IBZ-ASGN",
          TITLE : "IBIZ - Assign"
        },
        OUT:{
          ID  : "NOTI-IBZ-OUT",
          TITLE : "IBIZ - Out"
        },
      }
    },

  }
  //-- ------------------------------------------------------
  //-- ~ Get Notification Title by ID
  //-- ------------------------------------------------------
  getNotiTitle( notiId: String ){

    for( var x in this.NOTIFICATION ){
      for( var y in this.NOTIFICATION[ x ].NOTI ){

        var noti = this.NOTIFICATION[ x ].NOTI[ y ];
        if( notiId == noti[ "ID" ] ){
          return noti[ "TITLE" ];
        }

      }
    }

    return "No Title";

  }//-- END : getNotiTitle 
  //-- ------------------------------------------------------
  //-- ~ Get ID by Notification Title
  //-- ------------------------------------------------------
  getNotiId( notiTitle: String ){

    for( var x in this.NOTIFICATION ){
      for( var y in this.NOTIFICATION[ x ].NOTI ){

        var noti = this.NOTIFICATION[ x ].NOTI[ y ];
        if( notiTitle == noti[ "TITLE" ] ){
          return noti[ "ID" ];
        }
        
      }
    }

    return "No ID";

  }//-- END : getNotiId 

  //-- =====================================================
  //-- =====================================================
  

}
